/**
 * LYZNote 推广页入口
 * 组装各组件渲染完整的推广应用介绍页
 */
import '../../styles/global.css';
import {
  Navbar,
  Hero,
  Features,
  DownloadCTA,
  Footer,
  BRAND,
  NAV_LINKS,
  FOOTER_LINKS,
  COPYRIGHT,
  scrollToHash,
} from '../../components';

// ─── 页面配置数据 ───
const MS_STORE_URL = 'https://apps.microsoft.com/detail/9P3S7BXS082F';

const APP_CONFIG = {
  name: 'LYZNote',
  tagline: '思维落笔，即刻成文',
  description: '一款专注于效率与体验的 Markdown 笔记应用，支持多端同步、实时协作、知识图谱，让每一次记录都有迹可循。',
  downloadUrl: MS_STORE_URL,
  features: [
    {
      icon: '📝',
      title: 'Markdown 实时渲染',
      description: '所见即所得的编辑体验，支持 GFM、数学公式、流程图等扩展语法。',
    },
    {
      icon: '🔄',
      title: '多端同步',
      description: 'Windows 桌面端与 Web 端数据实时同步，随时随地记录灵感。',
    },
    {
      icon: '🔗',
      title: '双向链接',
      description: '构建个人知识图谱，笔记之间自由关联，发现意想不到的思维连接。',
    },
    {
      icon: '⚡',
      title: '极速搜索',
      description: '本地索引 + 模糊匹配，万篇笔记毫秒级检索，找到即是。',
    },
    {
      icon: '🎨',
      title: '主题定制',
      description: '丰富的主题与排版选项，打造专属于你的书写空间。',
    },
    {
      icon: '🔒',
      title: '隐私安全',
      description: '端到端加密，数据完全掌控在自己手中。支持本地存储与私有云部署。',
    },
  ],
  platforms: [
    { name: 'Windows', url: MS_STORE_URL, icon: '🖥️' },
  ],
};

// ─── 渲染页面 ───
function renderPage() {
  const root = document.getElementById('app');
  if (!root) return;

  // Navbar
  const navbar = new Navbar({
    brand: BRAND,
    links: NAV_LINKS,
    activeKey: 'lyznote',
  });
  root.appendChild(navbar.render());

  // Hero
  const hero = new Hero({
    title: APP_CONFIG.tagline,
    subtitle: APP_CONFIG.description,
    ctaText: '免费下载',
    ctaLink: '#download',
    secondaryText: '前往 Microsoft Store',
    secondaryLink: APP_CONFIG.downloadUrl,
    imageAlt: `${APP_CONFIG.name} 界面截图`,
  });
  root.appendChild(hero.render());

  // Features
  const features = new Features({
    title: '核心功能',
    items: APP_CONFIG.features,
  });
  const featuresEl = features.render();
  featuresEl.id = 'features';
  root.appendChild(featuresEl);

  // Download CTA
  const download = new DownloadCTA({
    title: '立即下载',
    subtitle: 'Windows 版，免费开始使用',
    platforms: APP_CONFIG.platforms,
  });
  const downloadEl = download.render();
  downloadEl.id = 'download';
  root.appendChild(downloadEl);

  // Footer
  const footer = new Footer({
    copyright: COPYRIGHT,
    links: FOOTER_LINKS,
  });
  root.appendChild(footer.render());

  // 页面内容此时才进入 DOM，补一次锚点定位
  scrollToHash();
}

// DOM Ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderPage);
} else {
  renderPage();
}
